
/* Fields ************************************************************/

import { ROLE_ADMIN } from "./User"

export const idField = () => ({ 
  key: 'id', 
  sortable: true,
  label: 'common.id',
})

export const nameField = (sortKey = 'name') => ({ 
  sortKey,
  key: 'name', 
  sortable: true,
  label: 'common.name',
})

export const activeField = () => ({ 
  $roles: ROLE_ADMIN,
  key: 'active', 
  label: 'common.active',
  formatter: (v,k,item) => item.active
})

export const merchantField = () => ({ 
  $roles: ROLE_ADMIN,
  key: 'merchant_name', 
  sortable: false,
  label: 'merchants.label'
})

/* Filters ***********************************************************/

export const merchantFilter = () => ({
  $roles: ROLE_ADMIN,
  name: 'merchant',
  label: 'merchants.label',
  type: 'relation',
  resource: 'merchants'
})

export const activeFilter = () => ({
  $roles: ROLE_ADMIN,
  name: 'active',
  label: 'common.active',
  default: true,
  type: 'boolean',
})

/* Batch actions *****************************************************/

export const deleteBatchAction = () => ({
  name: 'delete',
  icon: 'bx-trash',
  label: 'item.delete',
  variant: 'danger',
  confirm: true,
  async action(item) {
    return await item.$delete()
  }
})